<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="pn" id="_idParaDest-5"><a id="_idTextAnchor004"></a><a href="#/text/9780062839312_Contents#r_idParaDest-5"><span class="right_1" epub:type="pagebreak" id="page_6" title="6"><span class="right_1" epub:type="pagebreak" id="page_5" title="5">Part One</span></span></a></h2>
<p class="pepi">How we spend our days is, of course, how we spend our lives.</p>
<div class="top">
<p class="peps"><span class="smallcaps">ANNIE DILLARD,</span> <span class="smallcaps_italic">THE WRITING LIFE</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062839312_Part_1.vue?7f237d36